export default __webpack_public_path__ + "static/media/dashboard-nav.46028249.svg";